module.exports = __webpack_public_path__ + "h5/img/icon_address.b59a164a.png";